export const infoContent = `Some test content
`